export enum CandidateFilterType {
  AllActive = 'AllActive',
  WaitingForCandidate = 'WaitingForCandidate',
  NoSurveysComplete = 'NoSurveysComplete',
  OnePlusSurveysComplete = 'OnePlusSurveysComplete',
  AllSurveysComplete = 'AllSurveysComplete',
  AllInactive = 'AllInactive',
  InactiveHired = 'InactiveHired',
  InactiveHibernate = 'InactiveHibernate'
}
